import {CommonModule} from "@angular/common";
import {ChangeDetectionStrategy, Component} from '@angular/core';
import {MyButtonComponent} from '../../buttons/my-button/my-button.component';
import {RouterModule} from '@angular/router';

@Component({
  selector: 'app-setting-button',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MyButtonComponent
  ],
  templateUrl: './setting-button.component.html',
  styleUrl: './setting-button.component.css',
  host: {'class': 'flex flex-column align-items-center justify-content-center'},
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettingButtonComponent {
}
